import React, { useState } from 'react';
import { Button, Input, Badge, Label } from '@h2/ui';
import { X } from 'lucide-react';
import { useConfigurationStore } from '../../stores/useConfigurationStore';

interface SimpleTagsFieldProps {
  fieldId: string;
}

export const SimpleTagsField: React.FC<SimpleTagsFieldProps> = ({ fieldId }) => {
  const { formData, updateField } = useConfigurationStore();
  const [tagInput, setTagInput] = useState('');
  
  const tags = (formData[fieldId] as string[]) || [];

  const handleAddTag = () => {
    const inputTags = tagInput.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);
    const newTags = inputTags.filter(tag => !tags.includes(tag));
    
    if (newTags.length > 0) {
      const updatedTags = [...tags, ...newTags];
      updateField(fieldId, updatedTags);
      setTagInput('');
    }
  };

  const handleRemoveTag = (tagToRemove: string) => {
    const updatedTags = tags.filter(tag => tag !== tagToRemove);
    updateField(fieldId, updatedTags);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div className="space-y-3">
      <Label htmlFor={fieldId} className="text-sm font-medium">
        태그
      </Label>
      <div className="flex gap-2">
        <Input
          id={fieldId}
          placeholder="예시) 긴급작업, 고객사:하이브, 분야:교육"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-1"
        />
        <Button 
          type="button" 
          onClick={handleAddTag} 
          disabled={!tagInput.trim()}
        >
          추가
        </Button>
      </div>
      
      {tags.length > 0 && (
        <div className="flex gap-2 flex-wrap">
          {tags.map((tag, index) => (
            <Badge key={index} variant="secondary" className="text-sm">
              {tag}
              <button
                type="button"
                onClick={() => handleRemoveTag(tag)}
                className="ml-1 hover:text-destructive"
              >
                <X className="h-3 w-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};
